(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6296],{

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 36296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94960);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62062);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(145);
/* harmony import */ var ab_cta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92114);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(276);
/* harmony import */ var ab_paragraph_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2569);
/* harmony import */ var _ab_product_detail_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81676);
/* harmony import */ var _ab_product_detail_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ab_product_detail_scss__WEBPACK_IMPORTED_MODULE_7__);








var ProductDetail = function(param) {
    var producto = param.producto, classname = param.classname, invertir = param.invertir, imagen = param.imagen, i18n = param.i18n;
    var ref;
    // console.log("ProductDetail", producto);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-product-detail ".concat(classname || "").concat(invertir ? " rtl" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "image",
                style: {
                    backgroundImage: "url(".concat((imagen === null || imagen === void 0 ? void 0 : imagen.mediaItemUrl) || (producto === null || producto === void 0 ? void 0 : (ref = producto.image) === null || ref === void 0 ? void 0 : ref.mediaItemUrl), ")")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "detail",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        element: "h2",
                        children: producto === null || producto === void 0 ? void 0 : producto.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        element: "span",
                        className: "title",
                        children: (producto === null || producto === void 0 ? void 0 : producto.price) ? numeral__WEBPACK_IMPORTED_MODULE_1___default()(producto === null || producto === void 0 ? void 0 : producto.price).format("1,000.00$") : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_paragraph_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        content: producto === null || producto === void 0 ? void 0 : producto.shortDescription,
                        singleColumn: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_cta__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                type: "anadir",
                                text: t("anadir"),
                                selectedProduct: producto,
                                i18n: i18n
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                prefetch: false,
                                text: t("mas-info"),
                                href: "".concat(t("/tienda"), "/").concat(producto === null || producto === void 0 ? void 0 : producto.slug)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProductDetail);


/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81676:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);